import { useEffect } from "react";

const FacebookPixel = ({ pixelId }) => {
  useEffect(() => {
    if (!pixelId) {
      console.warn("No Facebook Pixel ID provided");
      return;
    }
    if (window.fbq && window.fbq.initialized) {
      // console.log("Facebook Pixel already initialized:", pixelId);
      return;
    }

    // Load Facebook Pixel script
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );

    // Init Pixel
    window.fbq("init", pixelId);
    window.fbq.initialized = true; 
    // console.log("Facebook Pixel Initialized:", pixelId);

    // Track PageView
    window.fbq("track", "PageView");
    // console.log("PageView Event Sent");
  }, [pixelId]);

  return null;
};

export default FacebookPixel;
